import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import React from 'react';

import SavedSearchesTable from '../../../components/SavedSearchesTable';
import { useTranslation } from '../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  zoomDialogPaperFullWidth: {
    maxWidth: '90%',
  },
  muiDialogContent: {
    '& [class*="MuiDialogContent"]': {
      maxWidth: 'unset',
    },
    '& [class*="MuiDialogActions"]': {
      marginBottom: 20,
      marginTop: 5,
    },
  },
  link: {
    textDecoration: 'none',
    color: '#06C !important',
    lineHeight: 1.5,
    fontFamily: 'Proxima Nova, Noto Sans, Helvetica, Arial, sans-serif',
    fontWeight: 400,
    fontSize: 14,
    '&:hover': {
      color: '#06C !important',
    },
  },
  savedSearchContainer: {
    '& thead > tr > th:nth-child(1) > svg': {
      display: 'none !important',
    },
  },
});

const PackageDetailsDialog = ({
  open,
  onClose,
  entityName,
  initialSearchName,
  title = '',
  packageId,
}) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const buttonProps = [{ label: translateString('Cancel'), onClick: onClose }];

  const customFilter = [
    {
      openGroup: false,
      fieldName: 'PARENT_GT_ID',
      sqlOperator: 'EQ',
      value: packageId,
      relationalOperator: 'AND',
      closeGroup: false,
    },
  ];

  return (
    <Modal
      open={open}
      title={translateString(title)}
      classes={{
        paperFullWidth: classes.zoomDialogPaperFullWidth,
        paper: classes.muiDialogContent,
      }}
      onClose={onClose}
      fullWidth
      disableEnforceFocus
      disableBackdropClick
      disableEscapeKeyDown
      buttonProps={buttonProps}
    >
      <div>
        <SavedSearchesTable
          title={translateString('Records')}
          entityName={entityName}
          initialSearchName={initialSearchName}
          initialTranslatedSearchName={null}
          dataKey=""
          customFilter={customFilter}
          referencedColumns={{}}
          dynamicParamCollection={{}}
          rowsPerPageOptions={[10, 25, 50]}
          extraColumns={[]}
          enableSorting
          showSearchSelector={false}
          onSavedSearchChange={() => {}}
          showFilters
        />
      </div>
    </Modal>
  );
};

export default PackageDetailsDialog;
